// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import 'swiper/dist/css/swiper.min.css';
import '../static/html/css/animate.css';


Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(ElementUI);

let locale = localStorage.getItem('mylang')||'ch'
document.title = locale=='en'?'CleverMax Intelligent':'南通明兴科技开发有限公司'
document.querySelector('meta[http-equiv="content-language"]').setAttribute('content',locale=='en'?'en':'zh-CN')
document.querySelector('meta[name="description"]').setAttribute('content',locale=='en'?'CleverMax Intelligent Hanger System':'南通明兴科技开发有限公司')

const i18n = new VueI18n({
  locale,
  messages: {
      'ch' : require('./lang/ch.js'),
      'en' : require('./lang/en.js'),
  }
})
//Vue.prototype._i18n = i18n
Vue.prototype.$i18nMsg = function(){
    return i18n.messages[i18n.locale].index
}

Vue.prototype._serverurl = 'https://www.clevermax.com.cn:9443';
//Vue.prototype._serverurl = 'https://192.168.1.108:9443';
Vue.prototype.$G = {
  mylang:i18n.locale
}
//console.log(i18n.locale);
Vue.prototype.$msgopen = function(){
  let sign = i18n.locale=='ch'?'af48d940a36189d3794e0e27454c2371channel1697174774_250':'af48d940a36189d3794e0e27454c2371channel1697852263_250'
  window.ytChatCore && window.ytChatCore.init({ sign });
}
Vue.prototype.$msgopen()
function getQueryString(name) {
	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	var r = window.location.search.substr(1).match(reg);
	if (r != null) {
			return unescape(r[2]);
	}
	return null;
}
console.log(getQueryString('token'))
Vue.prototype.$request = function(url,data={},f) {
  let xhr = new XMLHttpRequest();
  xhr.open('POST', this._serverurl + url, true);
  xhr.setRequestHeader('token', getQueryString('token')?getQueryString('token'):localStorage.getItem("token"));
  xhr.setRequestHeader('Content-type', 'application/json');
  xhr.onload = function() {
    if (this.status === 200) {
      //console.log(this.response);
			f&&f(JSON.parse(this.response))
    }
    if (this.status === 401) {
      //console.log(this.response);
      router.push('/login')
    }
  }
  xhr.send(JSON.stringify(data));
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js